var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellfishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED696A",
    d: "M112.2,46.3C105.5,23,82.6,5.4,57.9,8.4c-0.1-0.2-0.3-0.2-0.6-0.2c-22.6,2.5-40.9,19-47.6,40.3 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3c-0.8,7.3-0.4,14.8,1.7,21.8 c0.9,2.9,2,5.6,3.5,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.5,11.7,16.1,16c9.8,6.3,20.6,10.7,32.4,10.5c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4,25.2-8.8c9.9-6.3,16.9-14.7,20.5-25.8C115.1,70.7,115.6,58,112.2,46.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.0406,
    y1: 59.2355,
    x2: 111.9571,
    y2: 82.6847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981162,
    style: {
      stopColor: "#773033"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5759,
    style: {
      stopColor: "#C05355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8216,
    style: {
      stopColor: "#ED696A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M44.3,94L86,111c1.7-0.9,3.4-1.8,5-2.8c9.9-6.3,16.9-14.7,20.5-25.8c3.7-11.6,4.2-24.3,0.8-36.1 c-0.1-0.3-0.2-0.6-0.3-0.9L77.7,30.5L44.3,94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    d: "M77.4,85.3c0-0.7,3.9-3.5,4.3-4 c4.5-5.3,11.9-12.4,13.7-22c0,0,1.5-4,0-9.2c-1.5-5.1-5-7.4-5-7.4c-0.7-1.4-0.7-2.7-3.1-4.8c-2.3-2-5.5-2.9-5.5-2.9 c-1.9-1.4-1.6-3.1-6.3-4.3c-4.1-1-8.9-0.2-8.9-0.2c-1.9-0.9-2.8-1.8-6.3-1.8c-3.6,0-6.2,1.8-6.2,1.8c-3-0.3-4.9-0.8-8.4,0.2 C41.1,32,39,35.6,39,35.6c-2.3,0-3.5,0.5-5.1,1.4c-3,1.8-3.5,5.7-3.5,5.7c-3,1.9-5.4,4.2-6.1,6.8c-1.5,4.9,1.2,9.8,1.2,9.8 c1.8,9.6,9.8,17,14.3,22.3c0.4,0.5,3.8,3,3.8,3.7c-0.2,3.8,0.2,8.3,3.4,8.8h6.4c0.3,0,0.6,0.1,0.8,0.3c2.7,1.8,4.9,2.7,5.9,3 c0.3,0.1,0.7,0.1,1,0c0.9-0.3,3.1-1.2,5.9-3c0.3-0.2,0.5-0.3,0.8-0.3H74C77.2,93.6,77.7,89.1,77.4,85.3z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.4,
    y1: 75.1,
    x2: 54.2,
    y2: 30.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39,
    y1: 35.6,
    x2: 54.2,
    y2: 76.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.4,
    y1: 42.7,
    x2: 49.3,
    y2: 80
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 66.7,
    y1: 30.5,
    x2: 63.9,
    y2: 75.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 81.8,
    y1: 34.9,
    x2: 68.8,
    y2: 76.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ED696A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.5,
    y1: 42.7,
    x2: 71.5,
    y2: 80
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellfishIcon);
export default __webpack_public_path__ + "static/media/shellfish_icon.b4cd802a33f941c27f9b5f79f8eb7c47.svg";
export { ForwardRef as ReactComponent };